import React from 'react'
import { Checkbox, ListItemButton, ListItemIcon } from '@mui/material'
import RenderOption from 'components/route-manager/filters/route-filter/RenderOption'

const RenderFilterOption = (props, option, { selected }) => {
  const { id, value, routeColor } = option

  return (
    <ListItemButton dense disableGutters {...props}>
      <ListItemIcon sx={{ minWidth: 0 }}>
        <Checkbox checked={selected} />
      </ListItemIcon>
      <RenderOption
        routeId={id}
        routeName={value}
        bgcolor={routeColor}
        showStopCount={false}
        primaryTypographyProps={{ variant: 'body1', fontWeight: 400, noWrap: false }}
      />
    </ListItemButton>
  )
}

RenderFilterOption.propTypes = {}

export default RenderFilterOption
